import { render, staticRenderFns } from "./modal-reject-withdrawal.vue?vue&type=template&id=265c9f4f"
import script from "./modal-reject-withdrawal.vue?vue&type=script&lang=js"
export * from "./modal-reject-withdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports